import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/bom", params);
};

const getBomDetail = params => {
  return restApi.get("/api/bom/detail", { params });
};

const getAllForCSV = params => {
  return restApi.post("/api/bom/csv", params);
};

const upsert = data => {
  return restApi.post("/api/bom/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/bom/${ids}`);
};


const bomService = {
  getAll,
  getBomDetail,
  getAllForCSV,
  upsert,
  remove
};

export default bomService;